import React, { createRef, useState } from "react";
import { FixedCropper, ImageRestriction } from 'react-advanced-cropper';
import 'react-advanced-cropper/dist/style.css'

export default function CropPopup({ image, setActive, setImage, Imagetype }) {
  let height = Imagetype == 'signature' ? 150 : 100;
  let width = Imagetype == 'signature' ? 250 : 100;
  const cropperRef = createRef();

  const getCroppedData = () => {
    setImage(cropperRef.current.getCanvas()?.toDataURL());
    setActive();
  };
  return (
    <div className="bg-black bg-opacity-70 fixed z-[999] w-[100%] h-full left-0 top-0 flex justify-center items-center">
      <div className="w-[480px] max-w-full bg-white h-[500px] top-0 h-auto right-[320px] py-2 rounded-md">
        <div className="flex px-8 py-4 justify-between items-center">
          <h3 className="text-md font-bold tracking-[-.15px]">Crop Image</h3>
          <div
            className="bg-gray-100 px-2 py-2 rounded-md hover:bg-gray-200 transition-all cursor-pointer"
            onClick={() => setActive()}
          >
            <img src="/images/x-circle.svg" className="w-5 h-5" />
          </div>
        </div>
        <div className="flex px-8 pt-4 w-full h-[250px]">
          <div className="overflow-hidden rounded-md">
            <FixedCropper ref={cropperRef} src={image} stencilSize={{ width: width, height: height }} stencilProps={{movable: false, resizable: false }} imageRestriction={ImageRestriction.stencil} />
          </div>
        </div>
        <div className="flex px-8 mt-5">
          <button className="btn-md" onClick={getCroppedData}>
            Crop
          </button>
          <button
            className="ml-4 btn-md-disabled"
            onClick={() => setActive(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
